export const FLASH_MESSAGE = {
    msgShow: false,
    msgType: 'NONE',
    msg: "",
};
